<template>
  <div>
  <CCard class="bg-style2" style="min-height:200px;">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem">
        <span class="font-weight-bold h6">
          <CIcon :name="icon" size="lg"/> {{ caption }}
        </span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :fields="fields"
                :items="caseHistoryItems"
                :items-per-page="small ? 50 : 5"
                :dark="dark"
                pagination
            >
              <template #index="{index}">
                <td class="mt-3">
                  <label>{{ index + 1 }}</label>
                </td>
              </template>

              <template #action="{item}">
                <td class="mt-3">
                  <label>
                    {{
                      item.action === 'opened' ? 'เปิดเคส' :
                      item.action === 'closed' ? 'ปิดเคส' :
                      item.action === 'added_car' ? 'เพิ่มรถ' :
                      item.action === 'removed_car' ? 'ลบรถ' :
                      item.action === 'added_asset' ? 'เพิ่มสินทรัพย์' :
                      item.action === 'removed_asset' ? 'ลบสินทรัพย์' :
                      item.action === 'approved_asset' ? 'อนุมัติสินทรัพย์' :
                      item.action === 'rejected_asset' ? 'ปฏิเสธสินทรัพย์' :
                      item.action === 'approved_car' ? 'อนุมัติการขอยืมรถ' :
                      item.action === 'rejected_car' ? 'ปฏิเสธการขอยืมรถ' :
                      item.action
                    }}
                  </label>
                </td>
              </template>

              <template #by="{item}">
                <td class="mt-3">
                  <label>{{ item.by || 'ไม่ระบุ' }}</label>
                </td>
              </template>

              <template #at="{item}">
                <td class="mt-3">
                  <label>{{ formatDate(item.at) }}</label>
                </td>
              </template>

              <template #reason="{item}">
                <td class="mt-3">
                  <label>{{ item.reason || '-' }}</label>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import CaseControl from './CaseControl.vue'
import moment from 'moment'

export default {
  name: 'CaseHistory',
  components: { CaseControl },
  props: {
    icon: { type: String, default: 'cil-history' },
    caption: { type: String, default: 'ประวัติการเปิดปิดเคส' },
    caseData: { type: Object, default: () => ({}) },
    caseId: { type: String, default: '' },
    fields: {
      type: Array,
      default: () => [
        { key: "index", label: "#", _style: 'width:20px; text-align:center' },
        { key: "action", label: "รายการ" },
        // { key: "by", label: "ผู้ดำเนินการ" },
        { key: "at", label: "วันที่/เวลา" },
        { key: "reason", label: "รายละเอียด" }
      ]
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  computed: {
    // map case history จาก props โดยตรง
    caseHistoryItems() {
      return (this.caseData?.caseHistory || []).map((h, idx) => ({
        ...h,
        id: idx + 1
      }));
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      try {
        return moment(date).locale('th').format('DD/MM/YYYY HH:mm:ss');
      } catch (e) {
        return date;
      }
    },

    onCaseUpdated(updatedCase) {
      this.$emit('case-updated', updatedCase);
    }
  },
  watch: {
    caseData: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  }
}
</script>
